import React from 'react';
import { Text } from '@perch-labs/shrike';
import { TextProps } from 'types/style';

interface Props {
  label: string | React.ReactNode;
  labelTextStyle?: TextProps['textStyle'];
  value?: string | null;
}

export const DataAndLabel = ({
  label,
  labelTextStyle = 'paragraph500',
  value,
}: Props) => {
  return (
    <div>
      <Text className="notranslate" textStyle="heading800">
        {value || '—'}
      </Text>
      {typeof label === 'string' ? (
        <Text textStyle={labelTextStyle}>{label}</Text>
      ) : (
        label
      )}
    </div>
  );
};
